import { MOSCOW_WITH_SPB_AND_REGIONS } from 'shared/constants/regions';
import { isInRegionSelector } from 'shared/selectors/isInRegion';

export const selectIsMoscowOrSpbRegions = isInRegionSelector(MOSCOW_WITH_SPB_AND_REGIONS);
